import { render, staticRenderFns } from "./DiceSlide.vue?vue&type=template&id=ffdb87c2"
import script from "./DiceSlide.vue?vue&type=script&lang=js"
export * from "./DiceSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports